<template>
    <div
        class="fontSize_input"
        @input="setTextVariable"
    >
        <input
            id="fontSize"
            v-model.number="fontSize"
            type="number"
            name="fontSize"
        />
        <span>pt</span>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                fontSize: 14
            }
        },
        methods: {
            setTextVariable() {
                let payload = {
                    variableName: 'size',
                    value: this.fontSize
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            },
            setFontSize() {
                this.fontSize = this.getActiveElement.font.size;
            }
        },
        computed: {
            ...mapGetters([
                'getActiveElement'
            ])
        },
        watch: {
            getActiveElement: {
                deep: true,
                handler() {
                    this.setFontSize();
                }
            }
        },
        mounted() {
            this.setFontSize(); 
        }
    }
</script>

<style lang="scss" scoped>
    .fontSize_input {
        display: flex;
        align-items: center;
        height: 100%;

        input {
            width: 70%;
            background-color: #f5f5f5;
            border: none;
        }
    }
</style>